<kendo-card class="counter-card" *ngIf="device" >
  <kendo-card-header class="k-hstack">
    <div>
      <h1 kendoCardTitle><kendo-icon name="clip"></kendo-icon>  Device:        {{ device.device_name }} </h1>
      <p kendoCardSubtitle>Department: {{ device.department }} </p>

    </div>
  </kendo-card-header>
  <hr kendoCardSeparator/>
  <kendo-card-body>
    <app-cpxdev-evhi-hp  [cCPXDEV_EVHI]  = "device.cCPXDEV_EVHI_HP"    *ngIf="device.device_id == eCPXDEV_TYPE.eCPXDEV_TYPE_EVHI_HP"> </app-cpxdev-evhi-hp>
    <app-cpxdev-evhi-lp  [cCPXDEV_EVHI]  = "device.cCPXDEV_EVHI_LP"    *ngIf="device.device_id == eCPXDEV_TYPE.eCPXDEV_TYPE_EVHI_LP"> </app-cpxdev-evhi-lp>
    <app-cpxdev-tester   [cCPXDEV_TESTER]= "device.cCPXDEV_TESTER"  *ngIf="device.device_id == eCPXDEV_TYPE.eCPXDEV_TYPE_TESTER"> </app-cpxdev-tester>
  </kendo-card-body>
  <kendo-card-footer>
  </kendo-card-footer>
</kendo-card>







